import React from 'react';

// React.lazy wrapper that supports preloading for clean hydration of
// react-snap prerendered HTML.
//
// Problem: react-snap emits plain DOM with no Suspense dehydration markers.
// If hydration reaches a React.lazy component whose chunk isn't loaded yet,
// React can't suspend that boundary — it discards the server HTML and
// client-renders, logging hydration errors (#418/#423).
//
// Fix: index.js awaits preload() for the current route before calling
// hydrateRoot. Once preloaded, the wrapper renders the real component
// synchronously (no Suspense involvement), so hydration matches the static
// HTML exactly. Client-side navigations still go through React.lazy and the
// Suspense fallback as usual.
const loadedComponents = new Map();

export function lazyRoute(id, factory) {
  const Lazy = React.lazy(factory);

  const Wrapper = (props) => {
    const Loaded = loadedComponents.get(id);
    if (Loaded) return <Loaded {...props} />;
    return <Lazy {...props} />;
  };

  Wrapper.preload = () =>
    factory().then((mod) => {
      loadedComponents.set(id, mod.default);
      return mod.default;
    });

  Wrapper.displayName = `lazyRoute(${id})`;
  return Wrapper;
}
